import { getConfig } from "../../config/localizerConfig";

const localConfig = getConfig();

const cookie = {
  get(key) {
    const cookies = document?.cookie?.split("; ").reduce((acc, cookie) => {
      const [name, value] = cookie?.split("=");
      acc[name] = decodeURIComponent(value);
      return acc;
    }, {});
    return cookies[key] || "";
  },
  put({ key, value, expireTime }) {
    const expires = expireTime
      ? `; expires=${new Date(Date.now() + expireTime).toUTCString()}`
      : "";
    const domain = localConfig.domain;
    const domainPart = domain ? `; domain=${domain}` : "";
    const encodedValue = encodeURIComponent(value);
    const cookie = `${key}=${encodedValue}${expires}; path=/${domainPart}`;
    document.cookie = cookie;
  },
  remove(key) {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  },
};

export default cookie;
